import { TextItemOption, AbstractOptionSelectableTextItem } from "../../../../domain/document/items";

export class OptionSelectableItemHandler {
  public static getSelectedIndex(options: TextItemOption[]): number {
    if (!options) { return null; }
    for (let index = 0; index < options.length; ++index) {
      const option = options[index];
      if (option.isSelected) { return index; }
    }
    return null;
  }

  public static applySelectedOptionValue(item: AbstractOptionSelectableTextItem): void {
    if (item.shouldInputFree || !item.options || item.options.length === 0) { return; }
    if (item.label || this.isNotBlank(item.score) || item.code) {
      // 既に適用済み？
      return;
    }
    const selectedOption = item.options.find(o => o.isSelected);
    if (!selectedOption) {
      // 初期未選択オフ
      item.options[0].isSelected = true;
      item.applyOptionValue(item.options[0]);
      return;
    }
    if (!selectedOption.text && !this.isNotBlank(selectedOption.score) && !selectedOption.code) {
      // 初期未選択オン
      item.label = "";
      item.value = null;
      item.score = null;
      item.code = "";
      return;
    }
    // 選択対象のアイテムあり
    item.applyOptionValue(selectedOption);
  }

  private static isNotBlank(value: any): boolean {
    return (value !== null && value !== undefined);
  }
}
